import findIndex from 'lodash/findIndex';
import range from 'lodash/range';
import sample from 'lodash/sample';
import without from 'lodash/without';
import includes from 'lodash/includes';

import options from '../ui/interaction/children/animatedVisualizations/options';

export const SUBMISSION_INIT = 'submission/UI/SUBMISSION_INIT';
export const SUBMISSION_RESET = 'submission/UI/SUBMISSION_RESET';
export const SUBMISSION_ADD_ITEM = 'submission/UI/SUBMISSION_ADD_ITEM';
export const SUBMISSION_TOGGLE = 'submission/UI/SUBMISSION_TOGGLE';
export const SUBMISSION_REMOVE = 'submission/UI/SUBMISSION_REMOVE';
export const SUBMISSION_SET_DATA = 'submission/UI/SUBMISSION_SET_DATA';
export const SUBMISSION_SELECT = 'submission/UI/SUBMISSION_SELECT';

export const url = (action, state) => {
	const { payload } = action;
	const { channelId, streamId, challengeId } = payload;
	return {
		...state,
		url: {
			channelId,
			streamId,
			challengeId,
		},
	};
};

export const setData = (action, state) => {
	const { payload } = action;
	return {
		...state,
		data: payload,
	};
};


export const select = (action, state) => {
	const { payload } = action;
	return {
		...state,
		selected: payload,
	};
};

export const add = (action, state) => {
	const { payload } = action;
	const { data } = state;
	return {
		...state,
		data: [...data, payload],
	};
};

export const remove = (action, state) => {
	const { payload } = action;
	const { data, selected } = state;
	const newData = data.filter(item => item !== payload);
	const newSelected = selected.filter(item => item !== payload);
	return {
		...state,
		selected: newSelected,
		data: newData,
	};
};

export const toggle = (action, state) => {
	const { payload } = action;
	const { selected, focussed } = state;
	const focussedIndex = findIndex(selected, id => id === focussed);
	const notFocussedRandomIndex = sample(without(range(0, options.maxSelectedCount), focussedIndex));
	let newSelected = selected;
	if (!includes(selected, payload)) {
		newSelected = [
			...selected.slice(0, notFocussedRandomIndex),
			payload,
			...selected.slice(notFocussedRandomIndex + 1),
		];
	}
	return {
		...state,
		selected: newSelected,
		focussed: payload,
	};
};

export const reset = state => ({
	...state,
	focussed: null,
});



// WEBPACK FOOTER //
// ./src/actions/submission.js